import { createContext, useContext } from "react";

export type CompiledLayoutFillContextValue = {
  fillParent: boolean;
  designWidth: number;
  designHeight: number;
};

export const CompiledLayoutFillContext =
  createContext<CompiledLayoutFillContextValue | null>(null);

export function useCompiledLayoutFill(): CompiledLayoutFillContextValue | null {
  return useContext(CompiledLayoutFillContext);
}

const SIZE_MATCH_EPSILON = 1.5;

/** Returns true when a node dimension matches the design reference size (full-span). */
export function nodeSpansDesignSize(
  nodeSize: number,
  designSize: number,
): boolean {
  if (!Number.isFinite(nodeSize) || !Number.isFinite(designSize) || designSize <= 0) {
    return false;
  }
  return (
    Math.abs(nodeSize - designSize) <= SIZE_MATCH_EPSILON ||
    nodeSize >= designSize * 0.95
  );
}
